
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default {
  name: 'ServiceCard',
  mixins: [staticBlockMixin],
  props: {
    isCenter: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
